import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiError, client, unwrap } from "./api";

export const meKey = ["me"] as const;

export function useMe() {
  return useQuery({
    queryKey: meKey,
    queryFn: async () => {
      try {
        return await unwrap(client.me.$get());
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });
}

export type Me = NonNullable<ReturnType<typeof useMe>["data"]>;

export function useRefreshMe() {
  const qc = useQueryClient();
  // "all": the sign-in screens show no session, so by default nothing would be
  // refetched and the next screen would read the signed-out answer cached
  // before — and send the person back to the sign-in screen.
  return () => qc.invalidateQueries({ queryKey: meKey, refetchType: "all" });
}
